import Vue from 'vue'
import Vuex, { Store } from 'vuex'

import echarts from './modules/echarts'
import role from './modules/role'
Vue.use(Vuex)

export default new Store({
  state:{
    messageobj:{},
    numberobj:{},
    detailpage:{},
    // school:{},
  },
  modules: { // 配置应用中所有的功能相关的配置 总状态
    echarts: echarts,
    role: role,
  },
  mutations:{
    // 更改消息信息方法调用  存当前更改的消息对象
    setmessage(state,row){
      state.messageobj = row
    },
    // 修改设备型号   序列号
    setnumber(state,row){
      state.numberobj = row
    },
    // 序列号修改
    setdetailpage(state,row){
      state.detailpage = row
    },
    // 修改学校
    // setschool(state,row){
    //   state.school = row
    // }
  }
})




// WEBPACK FOOTER //
// ./src/store/index.js